import { render, staticRenderFns } from "./OrderConfirmation-Footer.vue?vue&type=template&id=4083dda2&"
import script from "./OrderConfirmation-Footer.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation-Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports